import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.system;

export const systemSelectors = {
  systems: createSelector(selector, (system) => system.systems),
};
